export const ExpandsDetails = (location, detail_heading) => ({
  type: 'Expands Details',
  data: {
    location,
    detail_heading,
  },
});
